import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
// routes
import Login from './routes/login'
import AlchemySingle from './routes/alchemy/single'
import AlchemySingleShare from './routes/alchemy/singleShare'
import AlchemyStart from './routes/alchemy/start'
import AlchemyBooks from './routes/alchemy/books'
import AlchemyMyProjects from './routes/alchemy/myProjects'
import DatasetsSingle from './routes/datasets/single'
import UserPreference from './routes/alchemy/preference'
import { ALABASTER } from './constants'
import Register from './routes/register'

const styles = {
  app: {
    textAlign: 'center',
    backgroundColor: ALABASTER
  }
}

/*
  import AllCharts from './routes/home/all'
  import ChartsNew from './routes/charts/new'
  import Datasets from './routes/datasets'
  import DatasetsNew from './routes/datasets/new'
  import ChartSingle from './routes/charts/single'
  import UserSingle from './routes/cc/single'
  import ProfileSingle from './routes/profile/single'
import ProfileFina from './routes/profile/fina'
import Home from './routes/home'

            <Route exact path="/" render={Home} />
  <Route path="/charts/new" component={ChartsNew} />
  <Route path="/datasets/new" component={DatasetsNew} />
  <Route path="/datasets" component={Datasets} />
  <Route path="/charts/:id" component={ChartSingle} />
  <Route path="/cc/preference" component={UserPreference} />
  <Route path="/all" component={AllCharts} />
  <Route path="/cc/:id" component={UserSingle} />
  <Route path="/:id" component={ProfileSingle} />
            <Route path="/:id/fina" component={ProfileFina} />
*/

export default class App extends Component {
  render() {
    return (
      <div style={styles.app}>
        <div>
          <Switch>
            <Route path="/start" component={AlchemyStart} />
            <Route path="/login" component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/preference" component={UserPreference} />
            <Route path="/books" component={AlchemyBooks} />
            <Route path="/projects" component={AlchemyMyProjects} />
            <Route path="/datasets/:id" component={DatasetsSingle} />
            <Route path="/share/:id/:tracker" component={AlchemySingleShare} />
            <Route path="/" component={AlchemySingle} />
          </Switch>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js